import { useEffect, useState } from 'react';
import './ClientsContent.css';
import { getAllClients } from '../../utilities/api/clients';
import ClientsItem from '../../components/ClientsItem/ClientsItem';
import NewClient from '../../components/NewClient/NewClient';
import ClientsFilter from '../../components/ClientsFilter/ClientsFilter';

export default function ClientsContent({ user, updateUser, isMobile, clientsPreferences, setDocketPreferences, favoriteClients, toggleNotifications }) {
  const [loading, setLoading] = useState(false)
  const [clients, setClients] = useState([])
  const [sortOrder, setSortOrder] = useState('desc')
  const [sortHeader, setSortHeader] = useState('createdAt')

  const getClients = async () => {
    setLoading(true)
    try {
      const allClients = await getAllClients(user._id)
      setClients(allClients)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const updateClients = (updatedClients) => {
    updatedClients.sort((a, b) => {
      if (sortOrder === 'asc') {
          return ((typeof(a[sortHeader])==='string' ? a[sortHeader].toLowerCase() : a[sortHeader]) > (typeof(b[sortHeader])==='string' ? b[sortHeader].toLowerCase() : b[sortHeader])) ? 1 : -1
      } else {
          return ((typeof(a[sortHeader])==='string' ? a[sortHeader].toLowerCase() : a[sortHeader]) < (typeof(b[sortHeader])==='string' ? b[sortHeader].toLowerCase() : b[sortHeader])) ? 1 : -1
      }
    });
    setClients(updatedClients)
  }

  const handleTableHeaderClick = (evt) => {
    const header = evt.target.id;
    const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc'
    setSortHeader(header);
    setSortOrder(newSortOrder);

    let sortedClients = [...clients]
    sortedClients.sort((a, b) => {
      if (newSortOrder === 'asc') {
        return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) > (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
      } else {
        return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) < (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
      }
    });
    setClients(sortedClients)
  }

  useEffect(() => {
    if (user.userType === 'admin' || user.userType === 'manager') {
      getClients()
    }
    // eslint-disable-next-line
  },[])
  return (
    <div className='ClientsContent'>
      <div className='clientsHeadingContainer'>
        <div className='section1'>
          <div className='title'>
            Clients
          </div>
          <div className='actionButtons'>
              <button className='newClientButton' title='Add New Client' data-bs-toggle="modal" data-bs-target={`#newClientModal`}>
                  <svg width="25" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="38" height="38" rx="10" fill="#1A5E9B"/>
                      <path d="M19 11V27V11ZM27 19H11H27Z" fill="#2173F0"/>
                      <path d="M19 11V27M27 19H11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  &nbsp;
                  New Client
              </button>
              <NewClient user={user} toggleNotifications={toggleNotifications} />
          </div>
        </div>
      </div>
      {loading ?
      <div className='loading'>
        <div className="spinner-border" role="status"></div>
      </div>
      :
      <div className='clientsMainSection'>
        <div className='header'>
          <div className='title'>
            Client List
          </div>
          <div className='filterContainer'>
            <ClientsFilter user={user} updateClients={updateClients} isMobile={isMobile} sortHeader={sortHeader} />
          </div>
        </div>
        <div className='clientsTable'>
          <table className=''>
            { clientsPreferences &&
            <>
            <thead>
              <tr>
                { !clientsPreferences.includes('companyName') &&
                <th id='companyName' onClick={handleTableHeaderClick} className='companyName' title='Click to sort by client name'>
                  <div className='tableHeaderWithArrow'><div>Client Name&nbsp;&nbsp;</div>
                  { sortHeader==='companyName'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                { !clientsPreferences.includes('clientID') &&
                <th id='clientID' onClick={handleTableHeaderClick} className='clientID' title='Click to sort by client ID'>
                  <div className='tableHeaderWithArrow'><div>Client ID&nbsp;&nbsp;</div>
                  { sortHeader==='clientID'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                { !clientsPreferences.includes('companyEmail') &&
                <th id='companyEmail' onClick={handleTableHeaderClick} title='Click to sort by Email'>
                  <div className='tableHeaderWithArrow'><div>Email&nbsp;&nbsp;</div>
                  { sortHeader==='companyEmail'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                <th id='companyPhoneNumber' className='companyPhoneNumber'>Phone</th>
                { !clientsPreferences.includes('province') &&
                <th id='province' onClick={handleTableHeaderClick} title='Click to sort by province'>
                  <div className='tableHeaderWithArrow'><div>Province&nbsp;&nbsp;</div>
                  { sortHeader==='province'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                { !clientsPreferences.includes('createdAt') &&
                <th id='createdAt' onClick={handleTableHeaderClick} className='createdAt' title='Click to sort by creation date'>
                  <div className='tableHeaderWithArrow'><div>Creation&nbsp;&nbsp;</div>
                  { sortHeader==='createdAt'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                { !clientsPreferences.includes('updatedAt') &&
                <th id='updatedAt' onClick={handleTableHeaderClick} className='updatedAt' title='Click to sort by last update date'>
                  <div className='tableHeaderWithArrow'><div>Last Update&nbsp;&nbsp;</div>
                  { sortHeader==='updatedAt'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
              </tr>
            </thead>
            <tbody>
              { clients?.length === 0 ?
              <tr>
                <td colSpan='12' className='noForms text-center'>No Clients Found</td>
              </tr>
              :
              <>
              {clients.map(form => (
                <ClientsItem user={user} updateUser={updateUser} key={form._id} clientItem={form} isMobile={isMobile} getClients={getClients}  toggleNotifications={toggleNotifications} clientsPreferences={clientsPreferences} setDocketPreferences={setDocketPreferences} favoriteClients={favoriteClients} />
              ))}
              </>
              }
            </tbody>
            </>
          }
          </table>
        </div>
        <div className='footer'>
          <div>
            page count
          </div>
          <div>
            toggle
          </div>
        </div>
      </div>
      }
    </div>
  )
}
